import { Link } from 'react-router-dom';
import withLinkButton from './withLinkButton';
export default withLinkButton(Link);
//# sourceMappingURL=index.js.map